module.exports = __webpack_public_path__ + "static/img/baj.a6b8a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/baj.jpg
// module id = sXn+
// module chunks = 1